import { PaginationModel } from '../../utils/pagination';
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ErrorResponse } from '@/utils/response';
import { axios, CustomAxiosResponse } from '@/utils/axios';
import { Blog } from './blog.model';

export interface BlogStoreInterface {
  blog: Blog | null;
  blogs: Blog[];
  defaultblogs: Blog[];
  highLightBlogs: Blog[];
  error: ErrorResponse | null;
  pagination: PaginationModel;
  fetchBlog(uuid: string): Promise<void>;
  fetchBlogs(params: BlogsParams): Promise<void>;
  fetchHighlightBlogs(): Promise<void>;
}

export interface BlogsParams {
  keyword: string;
}

@Module({
  namespaced: true,
  dynamic: true,
  name: 'blog',
  store,
})
class BlogStore extends VuexModule implements BlogStoreInterface {
  blog: Blog | null = null;
  blogs: Blog[] = [];
  defaultblogs: Blog[] = [];
  highLightBlogs: Blog[] = [];
  error: ErrorResponse | null = null;
  pagination = { ...this.defaultPagination };

  get defaultPagination(): PaginationModel {
    return {
      page: 1,
      limit: 4,
      totalPages: 1,
      totalRecords: 1,
      isResetPage: false,
    };
  }

  @Mutation
  updateBlog(params: Blog) {
    this.blog = params;
  }

  @Mutation
  updateHighlightBlogs(params: Blog[]) {
    this.highLightBlogs = params;
  }

  @Mutation
  updateBlogs(params: Blog[]) {
    if (this.blogs.length === 0 || this.pagination.isResetPage) {
      this.blogs = params;
      this.pagination.isResetPage = false;

      if (this.defaultblogs.length === 0 && params.length !== 0) {
        this.defaultblogs = params;
      }
    } else {
      this.blogs.push(...params);
    }
  }

  @Mutation
  setError(params: ErrorResponse) {
    this.error = params;
  }

  @Mutation
  updatePagination(params: PaginationModel) {
    this.pagination = params;
  }

  @Action
  async fetchBlog(uuid: string): Promise<void> {
    this.context.commit('updateBlog', null);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(`/blogs/${uuid}`);

      this.context.commit('updateBlog', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchBlogs(params: BlogsParams): Promise<void> {
    this.context.commit('updateBlogs', []);
    this.context.commit('setError', null);

    try {
      const { data, pagination }: CustomAxiosResponse = await axios.get(
        `/blogs`,
        {
          params: {
            ...params,
            page: this.pagination.page,
            limit: this.pagination.limit,
          },
        },
      );

      this.context.commit('updateBlogs', data);
      this.context.commit('updatePagination', pagination);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchHighlightBlogs(): Promise<void> {
    this.context.commit('updateHighlightBlogs', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(`/blogs/highlight`);

      this.context.commit('updateHighlightBlogs', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }
}

export default getModule(BlogStore);
